export default from './MothlyPaymentCalculator';



// WEBPACK FOOTER //
// ./src/sharedComponents/MothlyPaymentCalculator/index.js